import { useMemo } from 'react'
import { useAdminAllWaitlist } from '../../hooks/useAdmin'
import { DataTable } from '../../components/admin/DataTable'
import type { ColumnDef } from '@tanstack/react-table'
import type { AdminWaitlistEntry } from '../../types/admin'

function fmt(iso: string) {
  return new Date(iso).toLocaleString('en-US', {
    month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit',
  })
}

const columns: ColumnDef<AdminWaitlistEntry, unknown>[] = [
  {
    accessorKey: 'email',
    header: 'Email',
    meta: { label: 'Email' },
  },
  {
    accessorKey: 'createdAt',
    header: 'Signed up',
    meta: { label: 'Signed up' },
    cell: ({ getValue }) => <span className="text-muted">{fmt(getValue() as string)}</span>,
    sortingFn: 'datetime',
  },
]

export default function AdminWaitlistPage() {
  const { data, isLoading } = useAdminAllWaitlist()
  const entries = useMemo(() => data?.data ?? [], [data])

  return (
    <div>
      <div className="mb-6">
        <h1 className="m-0 text-[24px] font-bold">Waitlist</h1>
        <p className="text-[13px] text-muted mt-2 m-0 max-w-[560px] leading-[1.5]">
          Emails collected from the coming-soon page before launch.
        </p>
        {!isLoading && <div className="text-[13px] text-muted mt-1">{entries.length} signups</div>}
      </div>

      <DataTable
        columns={columns}
        data={entries}
        isLoading={isLoading}
        filterable
        exportable
        exportFilename="waitlist"
        emptyMessage="No waitlist signups yet."
        pageSize={100}
      />
    </div>
  )
}
